// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZjBx1","background":"Modal_background__z2sm8","content":"Modal_content__utlUG","close":"Modal_close__M1oFK"};